module.exports = __webpack_public_path__ + "static/media/app-store.57f682ca.svg";